import { render, staticRenderFns } from "./ChangeOfSecretaryForeign.vue?vue&type=template&id=2b617a62&scoped=true&"
import script from "./ChangeOfSecretaryForeign.vue?vue&type=script&lang=js&"
export * from "./ChangeOfSecretaryForeign.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfSecretaryForeign.vue?vue&type=style&index=0&id=2b617a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b617a62",
  null
  
)

export default component.exports